export default __webpack_public_path__ + "static/media/xylophone.ba1d900b.png";